import { each, throttle } from 'lodash'
import { app, menu, modal, search } from '../../utils/store'
import { activate, deactivate, available } from '../../utils/states'
import { media } from '../../utils/media'

export default class Main {
    constructor() {
        this.main = {
            toggler: document.getElementById('menu-toggler'),
            menu: document.getElementById('main-menu'),
            logo: document.getElementById('logo'),
            account: document.querySelector('[data-menu-account]'),
        }

        this.products = {
            menu: document.getElementById('products-menu'),
            nav: document.querySelector('[data-menu-products]'),
            toggler: document.querySelectorAll('[data-target="products-menu"]'),
        }

        this.rooms = {
            menu: document.getElementById('rooms-menu'),
            nav: document.querySelector('[data-menu-rooms]'),
            toggler: document.querySelectorAll('[data-target="rooms-menu"]'),
        }

        this.configurator = {
            nav: document.querySelector('[data-menu-configurator]'),
            toggler: document.querySelectorAll('[data-target="configurator-modal"]'),
        }

        this.store = {
            nav: document.querySelector('[data-menu-store]'),
            toggler: document.querySelectorAll('[data-target="store"]'),
        }

        this.contract = {
            nav: document.querySelector('[data-menu-contract]'),
            toggler: document.querySelectorAll('[data-target="contract"]'),
        }

        this.lang = {
            toggler: document.querySelector('#select-language .dropdown-toggler'),
            menu: document.querySelector('#select-language .dropdown-menu'),
        }

        app.header = document.querySelector('header')

        this.toggle()
        if (this.lang.toggler) { this.language() }
        window.addEventListener('scroll', throttle(() => this.onScroll(), 500));
    }

    toggle = () => {
        if (this.main.toggler) {
            this.main.toggler.onclick = () => {

                if (!modal.isOpen && !search.isActive) {
                    if (!menu.isOpen) { // if this.isMenuOpen = false
                        this.open(this.main, this.products)

                        menu.current = 'main'
                        menu.isOpen = true
                    } else {
                        if (menu.isBack) {
                            menu.current = 'main'
                            menu.isOpen = true

                            deactivate(this.products.nav)
                            deactivate(this.products.menu)
                            deactivate(this.rooms.nav)
                            deactivate(this.rooms.menu)
                            // deactivate(this.configurator.nav)
                            // deactivate(this.contract.nav)
                            // deactivate(this.store.nav)

                            this.main.toggler.classList.remove('back')
                            menu.isBack = false
                        } else {
                            menu.current = undefined
                            menu.isOpen = false

                            deactivate(this.products.nav)
                            deactivate(this.products.menu)
                            deactivate(this.rooms.nav)
                            deactivate(this.rooms.menu)
                            // deactivate(this.configurator.nav)
                            // deactivate(this.contract.nav)
                            // deactivate(this.store.nav)

                            each(this.products.toggler, (toggler) => available(toggler))
                            each(this.rooms.toggler, (toggler) => available(toggler))
                            each(this.configurator.toggler, (toggler) => available(toggler))
                            each(this.store.toggler, (toggler) => available(toggler))
                            each(this.contract.toggler, (toggler) => available(toggler))

                            this.close(this.main, this.products)
                        }
                    }
                }
            }
        }
    }

    open = (target, alternativeMenu) => {
        activate(target.menu)
        activate(target.logo)
        activate(target.toggler)
        activate(target.account)
        deactivate(alternativeMenu.menu)
        deactivate(alternativeMenu.nav)
        app.header.classList.add('inverted')
        document.body.classList.add('overflow-hidden')
        document.body.classList.add('navigation--open')
    }

    close = (target, alternativeMenu) => {
        deactivate(target.menu)
        deactivate(target.logo)
        deactivate(target.toggler)
        deactivate(target.account)
        activate(alternativeMenu.nav)
        deactivate(alternativeMenu.menu)
        menu.isBack ? null : app.header.classList.remove('inverted')
        menu.isBack ? null : document.body.classList.remove('overflow-hidden')
        menu.isBack ? null : document.body.classList.remove('navigation--open')
        menu.isBack ? null : document.body.classList.remove('navigation-products--open')
    }

    onScroll = () => {
        var scrollPosition = window.scrollY
        if (!menu.isOpen) {
            if (scrollPosition > 0) {
                activate(this.main.logo)
                activate(app.header)
                app.header.hasAttribute('data-reverse') ? app.header.classList.remove('reverted') : null
            } else {
                deactivate(this.main.logo)
                deactivate(app.header)
                app.header.hasAttribute('data-reverse') ? app.header.classList.add('reverted') : null
            }
        }
    }

    language = () => {
        if (this.lang.toggler) {
            this.lang.toggler.addEventListener('click', () => {
                this.lang.menu.classList.toggle('show')
            })
        }
    }
}
